import {connect} from 'react-redux';
import {createStructuredSelector} from 'reselect';

import {
  firstOrderPackagesById,
  firstOrderShippingStatusById,
} from '/redux/selector/client.selector';
import {currentScreen} from '/redux/selector/navigation.selector';

import {FirstOrder} from './FirstOrder';

export default connect(
  createStructuredSelector({
    firstOrderShippingStatus: firstOrderShippingStatusById,
    firstOrderPackages: firstOrderPackagesById,
    currentScreen,
  }),
)(FirstOrder);
